import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserRoles } from 'src/app/auth/current-user';
import { ApiService } from 'src/app/services/api.service';

@Component({
  standalone: false,
  selector: 'app-user-create',
  templateUrl: './user-create.component.html',
})
export class UserCreateComponent implements OnInit {
  userForm: FormGroup;
  roles = [
    { id: UserRoles.admin, name: 'Admin' },
    { id: UserRoles.user, name: 'User' },
  ];

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private router: Router
  ) {
    this.userForm = this.fb.group({
      name: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(4)]],
      passwordConfirmation: ['', Validators.required],
      playerId: [0, Validators.required],
      roles: [[UserRoles.user]],
      note: [''],
    }, { validators: this.passwordMatchValidator });
  }

  ngOnInit(): void {}

  passwordMatchValidator(g: FormGroup) {
    const password = g.get('password')?.value;
    const confirmation = g.get('passwordConfirmation')?.value;
    return password === confirmation ? null : { mismatch: true };
  }

  async onSubmit() {
    if (this.userForm.invalid) {
      return;
    }

    const { name, password, playerId, roles, note } = this.userForm.value;
    try {
      const newUser = await this.apiService.postCreateUser({
        name,
        password,
        playerId: Number.parseInt(playerId),
        roles,
        note
      });
      this.router.navigate(['/admin/user', newUser.id]);
    } catch (error) {
      console.error('Error creating user', error);
    }
  }

  onCancel() {
    this.router.navigate(['/admin/user/list']);
  }
}
